import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../scss/components/card.scss";
import ContainerInformationModal from "../pages/merchant-pages/invoiceOfMulti/ContainerInformationModal";
import NoCustomerContainerModal from "../pages/merchant-without-customer/NoCustomerInvoice/NoCustomerContainerInformationModal";
import { toDate } from "../utils/toDate";

const ShippedContainerCard = ({
  src,
  containersLength,
  currentDirection,
  index,
  containerInfo,
  subCompanyInfo,
  withCustomer = true,
  withDelete = false,
  handleAttemptDelete,
  invoice,
  setInvoice,
  handleConfirmEdit,
  onContainerChange
}) => {
  useEffect(() => {
    hasMoreThanNineLetters(containerInfo?.containerNumber);
    hasMoreThanNineLetters(
      containerInfo?.customer?.name || containerInfo?.customerName
    );
  }, []);
  const { t } = useTranslation("general");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const checkDetails =
    containersLength > 1
      ? `${t("container")} ${index + 1}`
      : `${t("containerDetails")}`;

  const [isLongThanNine, setIsLongThanNine] = useState(false);

  function hasMoreThanNineLetters(str) {
    if (str?.length > 15) {
      setIsLongThanNine(true);
    }
  }

  const TheModal = withCustomer
    ? ContainerInformationModal
    : NoCustomerContainerModal;
    

  return (
    <>
      <button className="card" onClick={openModal}>
        <div className="o-column o-column--vertical-align_start o-column--gap-size_400">
          <div className="u-width_full-width o-row o-column--vertical-align_center o-row--horizontal-align_space-between">
            <span className="card__title">{checkDetails}</span>
            {withDelete && (
              <button
                onClick={handleAttemptDelete}
                data-container-index={index}
                className="temp-delete-button"
              >
                ❌ {t("delete")}
              </button>
            )}
          </div>
          <div className="card__content-row">
            <div className="o-column o-column--vertical-align_start o-column--gap-size_200">
              <p className="card__detail">
                <strong> {t("containerNumber")} : </strong>
                {containerInfo?.containerNumber}
              </p>

              {withCustomer && (
                <p className="card__detail">
                  <strong>{t("customerName")} : </strong>
                  {containerInfo?.customer?.name || containerInfo?.customerName}
                </p>
              )}
              <p className="card__detail">
                <strong>{t("arrivalDate")} : </strong>
                {toDate(containerInfo?.expectedArrivalDate)}
              </p>
            </div>
            <div
              className={`card__image-container ${
                currentDirection === "ltr"
                  ? "card__image-container--right"
                  : "card__image-container--left"
              }`}
            >
              <img
                className={`${isLongThanNine ? "opacity" : ""} card__image`}
                src={src}
                alt="Container"
              />
            </div>
          </div>
        </div>
        <div className="card__view-more-container">
          <span className="card__view-more">{t("viewMore")}</span>
        </div>
      </button>

      {
        isModalOpen && withCustomer && (
          <ContainerInformationModal
            containerInfo={containerInfo}
            subCompanyInfo={subCompanyInfo}
            handleClose={closeModal}
            invoice={invoice}
            setInvoice={setInvoice}
            handleConfirmEdit={handleConfirmEdit}
            onContainerChange={onContainerChange}
          />
        )
      }

      {
        isModalOpen && !withCustomer && (
          <NoCustomerContainerModal
            containerInfo={containerInfo}
            subCompanyInfo={subCompanyInfo}
            handleClose={closeModal}
            invoice={invoice}
            setInvoice={setInvoice}
            handleConfirmEdit={handleConfirmEdit}
          />
        )
      }

      {/* {isModalOpen && (
        <TheModal
          containerInfo={containerInfo}
          subCompanyInfo={subCompanyInfo}
          handleClose={closeModal}
        />
      )} */}
    </>
  );
};

export default ShippedContainerCard;
